import AuditTrailPage from "../../../components/AuditTrailPage";
import { ADMIN_TABS } from "../../../utils/TabbarData";

const AdminAuditTrail = () => {
  return (
    <AuditTrailPage
      role="admin"
      tabs={ADMIN_TABS}
      selectedTabId={3}
      tabType="Audit Trail"
    />
  );
};

export default AdminAuditTrail;
